import axios from 'axios'
import router from '../../router/index'

export default {
  namespaced: true,
  state() {
    return {
      status: '',
      token: localStorage.getItem('token') || '',
      user: '',
      errorMessage: '',
    }
  },
  getters: {
    loggedIn: state => !!state.token,
    authStatus: state => state.status,
    userData: state => !!state.user,
    adminRole(state) {
      return state.user.active_role_id == state.user.primary_role_id
    },
    activeRole(state) {
      return state.user.active_role_id
    }
  },
  mutations: {
    AUTH_SUCCESS(state, data) {
      state.status = 'success';
      state.token = data;
      localStorage.setItem('token', data)
    },
    SET_USER(state,data) {
      state.user = data
    },
    AUTH_ERROR(state) {
      state.status = 'error';
    },
    SET_ERROR(state, data) {
      state.errorMessage = data
    },
    LOGOUT(state) {
      state.status = '';
      state.token = '';
      state.user = '';
      router.push('/login');
    }
  },
  actions: {
    async login({commit,dispatch}, user) {
      let urlLogin = process.env.VUE_APP_URL + 'auth/login';
       await axios({
        method: 'post',
        url: urlLogin,
        data:{
          "email": user.email,
          "password": user.password
        }
      }).then((data) => {
        //save token
        commit('AUTH_SUCCESS', data.data.access_token);
        localStorage.setItem('token', data.data.access_token);
        //load users
        dispatch('loadUser');
        //go to dashboard
        router.push('/')
      }).catch((e) => {
        commit('AUTH_ERROR');
        commit('SET_ERROR', e.response.data.message);
        commit('popups/errorLogin/SHOW_ERROR_LOGIN', true, {root: true});
        commit('popups/SHOW_OVERLAY', true, {root: true});
        localStorage.removeItem('token');
      });
    },

    async getRegisterEmail({commit}, key) {
      let {data} = await axios({
        method: 'get',
        url: `${process.env.VUE_APP_URL}auth/get-invitation-email?auth_key=${key}`
      }).catch(e => {

      });
      return data
    },

    async oauthlogin({commit, dispatch}, oauth) {
      let path = process.env.VUE_APP_URL + 'auth/oauth-login?provider='+ oauth.provider + '&code=' + oauth.code;
      await axios({
        method: 'get',
        url: path
      }).then((data) => {
        //save token
        commit('AUTH_SUCCESS', data.data.access_token);
        localStorage.setItem('token', data.data.access_token);
        //load users
        dispatch('loadUser');
        //go to dashboard
        router.push('/');
      }).catch((e) => {
        commit('AUTH_ERROR');
        commit('SET_ERROR', e.response.data.message);
        commit('popups/errorLogin/SHOW_ERROR_LOGIN', true, {root: true});
        commit('popups/SHOW_OVERLAY', true, {root: true});
        localStorage.removeItem('token');
      })
    },

    async recovery({commit, dispatch}, login) {
      let urlRecovery = process.env.VUE_APP_URL + 'auth/password-reset';
      await axios({
        method: 'post',
        url: urlRecovery,
        data: {
          email: login.email
        }
      }).then((data) => {
        commit('popups/SHOW_OVERLAY', true, {root: true});
        commit('popups/errorLogin/SET_RECOVERY_SUCCESS', true, {root: true})
      }).catch((e) => {
        commit('SET_ERROR', e.response.data.message);
        commit('popups/errorLogin/SHOW_ERROR_LOGIN', true, {root: true});
        commit('popups/SHOW_OVERLAY', true, {root: true});
      })
    },

    async getoauthurl({commit, dispatch}, provider) {
      let path = process.env.VUE_APP_URL + 'auth/get-oauth-url?provider='+ provider;
      await axios({
        method: 'get',
        url: path
      }).then((res) => {
        if(res.data && res.data.gauthpath) window.location.replace(res.data.gauthpath);
      }).catch((e) => {
      })
    },


    async loadUser({state,commit,dispatch}) {
      let urlUser = process.env.VUE_APP_URL + 'profile/get-data';
      if (state.token != null && state.token != 'null') {

        let data = await axios({
          method: 'get',
          url: urlUser,
          headers: {
            'Authorization': state.token
          }
        }).then((data) => {
          if (data) {
            commit('SET_USER', data.data);
            if (!!data.data.first_name) {
              commit('profile/SET_NAME', data.data.first_name, {root: true});
            }
            ;
            if (!!data.data.second_name) {
              commit('profile/SET_SURNAME', data.data.second_name, {root: true});
            }
            ;
            if (!!data.data.email) {
              commit('profile/SET_MAIL', data.data.email, {root: true});
            }
            ;
            if (!!data.data.language) {
              commit('profile/SET_LANGUAGE', data.data.language, {root: true});
            }
            ;
            if (!!data.data.contacts.avatar_url) {
              commit('profile/SET_AVATAR', data.data.contacts.avatar_url, {root: true});
            }
            ;
            if (!!data.data.contacts.phone) {
              commit('profile/SET_TEL', data.data.contacts.phone, {root: true});
            }
            ;
            if (!!data.data.contacts.zip) {
              commit('profile/SET_POSTAL_CODE', data.data.contacts.zip, {root: true});
            }
            ;
            if (!!data.data.contacts.address) {
              commit('profile/SET_ADDRESS', data.data.contacts.address, {root: true});
            }
            ;
            if (!!data.data.contacts.country) {
              commit('profile/SET_COUNTRY', data.data.contacts.country, {root: true});
            }
            ;
            if (!!data.data.contacts.city) {
              commit('profile/SET_CITY', data.data.contacts.city, {root: true});
            }
            ;
            if (!!data.data.contacts.region) {
              commit('profile/SET_REGION', data.data.contacts.region, {root: true});
            }
            ;
            if (!!data.data.auth_by) {
              commit('profile/SET_AUTH_BY', data.data.auth_by, {root: true});
            }
          }
          dispatch('roles/getAllNotify', null, { root: true })
        }).catch((e) => {
          if (e.response.status == 403) {
            commit('LOGOUT');
          }
        })
      }
    },

    async register({commit, dispatch}, user) {
      let urlRegister = process.env.VUE_APP_URL + 'auth/sign-up';
      await axios({
        method: 'post',
        data: {
          email: user.mail,
          password: user.pass,
          first_name: user.name,
          second_name: user.surname,
          phone: user.tel,
          faceless: false,
          language: user.language,
          auth_key: user.auth_key
        },
        url: urlRegister
      }).then((data) => {
        //save token in vuex and localStorage
         commit('AUTH_SUCCESS', data.data.access_token);
         localStorage.setItem('token', data.data.access_token);
         //loadUser
         dispatch('loadUser');
         //go to dashboard
         //router.push('/')
      }).catch((e) => {

        if (e.response.data.message) {
          if (e.response.data.message.includes('email')) {
            commit('AUTH_ERROR');
            commit('SET_ERROR', 'mail');
          }
        }
        commit('SET_ERROR', e.response.data.message);
        commit('popups/errorLogin/SHOW_ERROR_LOGIN', true, {root: true});
        commit('popups/SHOW_OVERLAY', true, {root: true});
        localStorage.removeItem('token');
      })
    },

    async relogin({state,commit,dispatch}) {
      let reloginUrl = '';
      const token = state.token;

      let data = await axios({
        method: 'post',
        url: reloginUrl,
        headers: {
          'Authorization': token
        }
      }).then(res => {
        dispatch('loadUser', token)
      })
    },

    async logout({state, commit}) {
      await axios({
        method: 'post',
        url: `${process.env.VUE_APP_URL}auth/logout`,
        headers: {
          'Authorization': state.token
        }
      }).then(() => {
        commit('LOGOUT');
        localStorage.removeItem('token');
        router.go();
      }).catch(e => {
        console.log(e)
      })
    }
  }
}
